module.exports = __webpack_public_path__ + "static/it-takes-an-island-a797a73047aa34e689c9f0987a280926.mp4";